// extracted by mini-css-extract-plugin
export default {"image":"IdealImage_image__sdI9b"};